/*
 * Holded tax-invoice cart-attribute controller.
 * Works on the cart page and the AJAX cart drawer via event delegation,
 * so it survives drawer re-renders without re-binding.
 */
(function () {
  'use strict';

  var ATTR_REQUIRED = 'Tax Invoice Required';
  var ATTR_TAX_ID = 'Tax ID';
  var ATTR_COMPANY = 'Company Name';
  var DEBOUNCE_MS = 400;

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  function getRoot(el) {
    return el && el.closest ? el.closest('[data-holded-invoice]') : null;
  }

  function setVisible(root, visible) {
    var fields = root.querySelector('[data-holded-invoice-fields]');
    if (!fields) return;
    if (visible) fields.removeAttribute('hidden');
    else fields.setAttribute('hidden', '');
  }

  function setError(root, msg) {
    var el = root.querySelector('[data-holded-invoice-error]');
    if (!el) return;
    if (msg) {
      el.textContent = msg;
      el.removeAttribute('hidden');
    } else {
      el.setAttribute('hidden', '');
    }
  }

  function isValid(root) {
    var toggle = root.querySelector('[data-holded-invoice-toggle]');
    if (!toggle || !toggle.checked) return true;
    var fields = root.querySelectorAll('[data-holded-invoice-required]');
    for (var i = 0; i < fields.length; i++) {
      if (!fields[i].value || !fields[i].value.trim()) return false;
    }
    return true;
  }

  function syncRoots(updater) {
    document.querySelectorAll('[data-holded-invoice]').forEach(updater);
  }

  function updateCartAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart update failed: ' + r.status);
      return r.json();
    }).catch(function (err) {
      console.error('[holded-invoice]', err);
    });
  }

  /* ---------- Toggle change ---------- */
  document.addEventListener('change', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-holded-invoice-toggle]');
    if (!toggle) return;
    var root = getRoot(toggle);
    if (!root) return;

    if (toggle.checked) {
      setVisible(root, true);
      updateCartAttributes(payloadObj(ATTR_REQUIRED, 'true'));
      // Mirror the new state into any other instances on the page.
      syncRoots(function (r) {
        if (r === root) return;
        var t = r.querySelector('[data-holded-invoice-toggle]');
        if (t) t.checked = true;
        setVisible(r, true);
      });
    } else {
      setVisible(root, false);
      // Clear inputs in the DOM and on the cart.
      root.querySelectorAll('[data-holded-invoice-field]').forEach(function (i) { i.value = ''; });
      setError(root, '');
      var cleared = {};
      cleared[ATTR_REQUIRED] = '';
      cleared[ATTR_TAX_ID] = '';
      cleared[ATTR_COMPANY] = '';
      updateCartAttributes(cleared);
      // Mirror.
      syncRoots(function (r) {
        if (r === root) return;
        var t = r.querySelector('[data-holded-invoice-toggle]');
        if (t) t.checked = false;
        r.querySelectorAll('[data-holded-invoice-field]').forEach(function (i) { i.value = ''; });
        setVisible(r, false);
        setError(r, '');
      });
    }
  });

  function payloadObj(key, value) {
    var o = {}; o[key] = value; return o;
  }

  /* ---------- Field input persistence ---------- */
  var persistField = debounce(function (input) {
    var root = getRoot(input);
    if (!root) return;
    var name = input.getAttribute('name') || '';
    var match = name.match(/attributes\[(.+)\]/);
    if (!match) return;
    var key = match[1];
    var value = (input.value || '').trim();
    updateCartAttributes(payloadObj(key, value));
    if (isValid(root)) setError(root, '');

    // Mirror into the other instance (drawer <-> cart page).
    syncRoots(function (r) {
      if (r === root) return;
      var twin = r.querySelector('input[name="attributes[' + key + ']"]');
      if (twin) twin.value = value;
    });
  }, DEBOUNCE_MS);

  document.addEventListener('input', function (e) {
    var field = e.target.closest && e.target.closest('[data-holded-invoice-field]');
    if (!field) return;
    persistField(field);
  });

  /* ---------- Block checkout when invalid ---------- */
  function blockIfInvalid(e, root) {
    if (isValid(root)) return false;
    e.preventDefault();
    e.stopPropagation();
    setError(root, 'Completa NIF/CIF y razón social para continuar.');
    var first = root.querySelector('[data-holded-invoice-required]');
    if (first) first.focus();
    return true;
  }

  // Cart-page form submit (when user clicks "Checkout" inside <form action="/cart">).
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[action^="/cart"], form[action="/cart"]');
    if (!form) return;
    var root = form.querySelector('[data-holded-invoice]') || document.querySelector('[data-holded-invoice]');
    if (!root) return;
    blockIfInvalid(e, root);
  }, true);

  // Drawer "Checkout" buttons that are not inside a <form>.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"], [href*="/checkout"]');
    if (!btn) return;
    // Find the closest visible root (drawer first, then cart page).
    var scope = btn.closest('cart-drawer, .cart-drawer, .drawer, form, body');
    var root = (scope && scope.querySelector('[data-holded-invoice]')) ||
               document.querySelector('[data-holded-invoice]');
    if (!root) return;
    blockIfInvalid(e, root);
  }, true);
})();
